<template>
  <div class="member">
    <!-- 右侧员工列表 -->
    <div class="member_r">
      <div class="member_r_t_l">
        <div class="member_r_t_left">
          <div
            :class="[sidebarShowIcon ? '' : 'left', 'approval_search']"
            tabindex="1"
          >
            <el-tooltip
              class="item"
              effect="dark"
              content="请输入姓名、员工工号、设备工号、手机号"
              placement="top-start"
            >
              <el-input
                v-model="searchForm.likeString"
                @keyup.enter.native="seachmemResult"
                class="department_search_inp"
                placeholder="请输入姓名、员工工号…"
                style="width: 200px"
              >
              </el-input>
            </el-tooltip>
            <img
              src="@/assets/structure/delete.png"
              class="searchicon"
              @click="clearupMember"
              v-if="searchMemicon"
            />
            <img
              src="@/assets/structure/search.png"
              class="searchicon_t"
              @click="seachmemResult"
            />
          </div>
          <div class="member_r_t_dowm">
            <el-select
              v-model="searchForm.leaveType"
              @change="seachmemResult"
              placeholder="离职类型"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="member_r_t_right" @click="startDownload">导出报表</div>
      </div>
      <div class="memeber_table" ref="memeberTable">
        <el-table
          height="100%"
          ref="multipleTable"
          :data="tableData"
          :header-cell-style="getRowClass"
          tooltip-effect="dark"
          class="m_table"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/nodata.png" class="nodata" />
              <div>无数据</div>
            </div>
          </template>
          <el-table-column prop="name" label="姓名" width="150">
            <template slot-scope="scope">
              <div class="member_name">
                <img
                  :src="scope.row.headUrl"
                  class="member_head"
                  v-if="scope.row.headUrl"
                />
                <img src="@/assets/head.png" v-else class="member_head" />
                <div>{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="员工工号" prop="jobNumber" width="150">
          </el-table-column>
          <el-table-column label="设备工号" prop="deviceNumber" width="150">
          </el-table-column>
          <el-table-column label="部门" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.umsDepartment" class="ellipsis">
                {{ scope.row.umsDepartment.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="job" label="职位">
            <template slot-scope="scope">
              <div v-if="scope.row.job">{{ scope.row.job }}</div>
              <div v-else>--</div>
            </template>
          </el-table-column>
          <el-table-column label="离职类型" width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.leaveType == 0">自离</div>
              <div v-if="scope.row.leaveType == 1">辞退</div>
              <div v-if="scope.row.leaveType == 3">其他</div>
            </template>
          </el-table-column>
          <el-table-column prop="timeQuit" label="离职日期" width="200">
            <template slot-scope="scope">
              <div v-if="scope.row.timeQuit">
                {{ hadleQuit(scope.row.timeQuit) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="leaveReason" label="离职原因" width="200">
          </el-table-column>
          <el-table-column label="经办人" width="120">
            <template slot-scope="scope">
              <div v-if="scope.row.umsUser">
                {{ scope.row.umsUser.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="生物值特征(近红外)" width="200">
            <template slot-scope="scope">
              <div class="structure_feature">
                <img
                    src="@/assets/structure/face.png"
                    class="feature"
                    v-if="scope.row?.featureStatus?.nir?.face"
                />
                <img
                    src="@/assets/structure/fingerprint.png"
                    class="feature"
                    v-if="scope.row?.featureStatus?.nir?.finger && scope.row?.featureStatus?.nir?.finger?.some(f => f == true)"
                />
                <img
                    src="@/assets/structure/vein.png"
                    class="feature"
                    v-if="scope.row?.featureStatus?.nir?.hand"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="生物特征值(可见光)" width="200">
            <template slot-scope="scope">
              <div class="structure_feature">
                <svg v-if="scope.row?.featureStatus?.vl?.face" t="1749788776648" class="feature" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6757" width="30" height="30"><path d="M682.666667 554.666667v21.333333c0 81.066667-68.266667 149.333333-149.333334 149.333333S384 657.066667 384 576V554.666667h42.666667v21.333333c0 59.733333 46.933333 106.666667 106.666666 106.666667s106.666667-46.933333 106.666667-106.666667V554.666667h42.666667zM213.333333 426.666667V213.333333h213.333334v42.666667H256v170.666667H213.333333z m0 213.333333h42.666667v170.666667h170.666667v42.666666H213.333333v-213.333333z m640-213.333333h-42.666666V256h-170.666667V213.333333h213.333333v213.333334z m0 213.333333v213.333333h-213.333333v-42.666666h170.666667v-170.666667h42.666666z m-384-256v85.333333h-42.666666V384h42.666666z m170.666667 0v85.333333h-42.666667V384h42.666667z" fill="#85D2FC" p-id="6758"></path></svg>
                <svg v-if="scope.row?.featureStatus?.vl?.finger && scope.row?.featureStatus?.vl?.finger?.some(f => f == true)"  style="margin-top: 2px;width: 28px;height: 28px;" t="1749788738299" class="feature" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5594" width="30" height="30"><path d="M749.290667 780.8a32 32 0 0 1-64.021334 0V646.4c0-98.965333-80.266667-179.2-179.274666-179.2-99.008 0-179.264 80.234667-179.264 179.2v115.2a32 32 0 0 1-64.032 0V646.4c0-134.314667 108.928-243.2 243.306666-243.2 134.357333 0 243.285333 108.885333 243.285334 243.2v134.4z m149.930666-500.906667a32 32 0 0 1-4.042666 45.077334 32.021333 32.021333 0 0 1-45.088-4.032C765.418667 219.626667 640.608 160 505.994667 160 377.386667 160 257.6 214.4 173.12 308.032a32.021333 32.021333 0 0 1-45.226667 2.325333 32 32 0 0 1-2.314666-45.194666C222.08 158.229333 359.072 96 505.994667 96c153.792 0 296.512 68.202667 393.226666 183.893333zM883.733333 627.2a32 32 0 0 1-64.032 0c0-130.218667-80.128-245.461333-199.402666-292.138667a32 32 0 1 1 23.338666-59.594666C787.264 331.658667 883.733333 470.421333 883.733333 627.2zM505.994667 249.6a32 32 0 1 1 0 64c-173.258667 0-313.717333 140.405333-313.717334 313.6a32 32 0 0 1-64.021333 0c0-208.533333 169.12-377.6 377.738667-377.6z m0 371.2a25.6 25.6 0 0 0-25.6 25.066667l0.192 5.152a1953.109333 1953.109333 0 0 1 1.205333 61.845333c0.010667 19.882667-0.448 36.48-1.525333 49.066667-3.573333 41.877333-15.082667 78.410667-32.106667 109.493333a222.293333 222.293333 0 0 1-23.584 35.061333c-5.173333 6.229333-9.472 10.666667-12.437333 13.333334a32.021333 32.021333 0 0 1-45.205334-2.442667 32 32 0 0 1 2.432-45.184c-0.074667 0.064 0.256-0.245333 0.938667-0.96 1.429333-1.461333 3.093333-3.328 4.96-5.568a158.602667 158.602667 0 0 0 16.746667-24.970667c12.864-23.488 21.674667-51.477333 24.469333-84.202666 0.885333-10.378667 1.301333-25.386667 1.290667-43.594667a1643.466667 1643.466667 0 0 0-1.173334-59.573333l-0.213333-5.578667-0.021333-1.344c0-49.493333 40.128-89.6 89.632-89.6a89.621333 89.621333 0 0 1 89.632 89.6v171.050667a32 32 0 0 1-64.021334 0V646.4a25.6 25.6 0 0 0-25.6-25.6z" fill="#85D2FC" p-id="5595"></path></svg>
                <svg v-if="scope.row?.featureStatus?.vl?.hand" t="1749788653382" class="feature" style="margin-top: 5px;" viewBox="0 0 1170 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4386" width="30" height="30"><path d="M318.794943 902.245088l-11.059404-109.82293c-28.186262-20.759212-134.579762-104.871564-156.800034-213.76104-9.7201-40.199413-30.905455-82.103395-53.89684-117.513782-28.774744-48.803427-41.599595-94.441226 0-139.774638 11.221744-13.778597 28.774744-19.521371 47.565585-19.846051 63.129922 0 119.847418 104.546884 135.310292 183.789039l5.519556 6.290671-5.519556-335.942094c0-1.298719-0.365265-47.078566 27.800704-74.87927 13.271285-12.885728 27.394855-17.248612 46.753887-16.721008h8.482258c13.71772 0.202925 27.070175 10.349167 38.900695 16.721008 1.663984-22.139101 10.389752-37.906362 25.751163-55.094098 14.103277-13.63655 31.859202-23.133433 52.395197-22.524659 17.79651-0.40585 38.616599 7.325587 50.345656 19.561956 14.001815 16.66013 14.103277 37.074371 15.604921 58.036508 16.132526-10.410045 38.21075-20.698335 57.488611-16.700715 51.705252 8.360504 58.848207 62.561732 61.486231 101.584181 9.598346-3.571477 25.040927-4.707857 35.308924-3.388845 72.647097 7.50822 74.635761 65.341803 73.925524 92.83812-0.730529 27.496318-22.707291 192.068373-26.035259 213.801625 4.159959 26.299061 35.674189 251.626817-88.454943 341.928376l5.945698 80.642337-346.818866 10.755017zM151.503695 349.39662c-8.563429 0.771114-20.759212 4.383177-25.609116 10.876772-25.771456 28.00363-9.009863 53.166311 19.176398 100.934822a379.915909 379.915909 0 0 1 50.386241 118.548699c21.976762 107.793682 148.338067 195.944238 149.596201 196.796522l6.087746 4.302007v91.924958l271.310528-8.401089-4.707857-64.489518 7.142955-4.525224c117.818169-76.989689 79.952392-308.060219 79.505957-310.373562v-4.119375c9.436006-63.109629 27.59778-186.690864 28.064507-208.890843 1.156672-52.577829-13.352455-64.570688-40.605263-67.411636-6.29067-0.811699-12.682803 0.710237-17.735632 4.241129-5.073121 3.5106-8.360504 8.725769-9.192495 14.488835l-30.844578-3.693233c0-1.055209 11.505839-99.494055-39.002157-107.590757-37.96724-6.108038-47.078566 25.122097-49.128107 38.068703h-15.645506l-15.544043-1.258134v-2.942411c3.226505-23.985718 3.571477-70.272876-14.833807-89.205765a28.389187 28.389187 0 0 0-21.875299-8.624306 40.99082 40.99082 0 0 0-30.134341 10.5318c-20.698335 20.292485-19.561956 63.109629-18.182067 80.967016a56.818959 56.818959 0 0 1 1.623399 15.361411l-6.797982 139.368789-23.823378-136.730766s-0.913162-5.783358-1.724861-14.813514c-3.91645-15.686091-16.436913-24.635077-37.96724-25.365606a37.64256 37.64256 0 0 0-28.652989 9.578053c-14.610589 14.509127-15.544044 43.324456-14.61059 53.206896l12.682803 340.304978a20.292485 20.292485 0 0 1-28.713866 19.196691l-40.686433-18.587917a13.697428 13.697428 0 0 1-7.832899-10.328875c-13.129238-78.673965-65.341803-161.325258-101.726229-161.325258z" p-id="4387" fill="#85D2FC"></path><path d="M431.337067 154.913441l2.719193 245.133222c-13.71772 10.795602-20.57658 8.502551-20.57658-6.899445s-3.388845-90.017465-10.20712-223.826112l28.064507-14.407665z m114.611956-4.829611l-20.191022 249.962833-20.170731-2.293051 9.172204-251.870327 31.189549 4.200545z m118.974842 73.215287l-39.428299 204.223571-21.510035-4.383177 30.093756-203.533627 30.844578 3.693233zM508.428218 753.054737c-9.943318-13.129238-23.661038-21.550619-35.958284-28.896499-9.456298-5.255754-20.353363-11.039112-32.670901-14.184447-12.297246-3.145335-25.548239-3.67294-38.312212-3.145336a531.521066 531.521066 0 0 0-64.834491 5.255754c-2.374221 0.527605-5.215169-1.582814-5.215168-4.728149-0.466727-2.638023 1.420474-5.783358 4.261422-5.783358a462.648371 462.648371 0 0 1 65.788237-5.255754c13.250993 0 26.968713 0 40.686433 3.67294 13.250993 3.693232 25.568531 9.983903 34.558102 15.239656 12.784266 7.34588 27.92246 16.802178 38.799232 30.986625 1.907494 2.110418 1.420474 5.783358-0.466727 7.366172-0.466727 1.034917-1.420474 1.562521-2.840948 1.562522a4.180252 4.180252 0 0 1-3.794695-2.090126zM470.298638 566.221825a91.924958 91.924958 0 0 1-24.614784-13.595965 94.339764 94.339764 0 0 1-20.73892-23.742208c-1.298719-2.252466-1.298719-6.2095 0.852284-7.914069 1.724861-1.684276 4.748442-1.684276 6.047161 1.136379 5.194876 8.482259 11.242037 15.259949 18.161774 20.921552 6.047161 4.525224 13.39304 8.482259 22.889924 12.439294 22.889923 9.050448 46.672716 13.007483 70.414923 11.302914 2.171296 0 4.322299 2.272758 4.3223 5.661603 0 3.388845-1.724861 5.661603-4.3223 5.661604-3.02358 0.56819-6.473303 0.56819-9.943317 0.568189a162.339882 162.339882 0 0 1-63.069045-12.439293zM604.310211 608.06493c-2.577146 0-5.154291-1.968371-5.154291-4.931074a160.919408 160.919408 0 0 0-15.422289-63.535772l-0.507312-1.481351a51.0356 51.0356 0 0 1-4.606394-12.317539c-0.527605-2.455391 1.542229-5.418094 4.099082-5.905113 2.577146-0.48702 5.661603 1.481351 6.168915 3.936742 0.507312 3.449722 2.049541 6.412425 3.59177 9.862148l0.507312 1.481352a161.325258 161.325258 0 0 1 16.436913 66.965201c0 3.957035-2.029249 5.925406-5.133998 5.925406z" p-id="4388" fill="#85D2FC"></path><path d="M572.187207 813.99307a5.438386 5.438386 0 0 1-4.261422-5.073121c2.840948-23.417528-13.940937-90.646532-49.777466-131.677937-35.856821-41.011113-131.941739-66.376719-155.765117-70.962821a4.768734 4.768734 0 0 1-3.814987-5.519556 4.931074 4.931074 0 0 1 5.72248-3.67294c26.217891 5.052829 117.939924 26.319353 161.954325 74.656053 44.014401 48.296115 54.525908 112.379783 51.664668 138.110655-0.953747 2.293051-2.840948 4.139667-5.235461 4.139667h-0.48702z" p-id="4389" fill="#85D2FC"></path><path d="M96.389305 0.000609C43.162116 0.000609 0 41.965468 0 93.751891v71.226623c0 5.174584 4.322299 9.375128 9.63893 9.375128h53.511284c5.336924 0 8.847524-4.200544 8.847524-9.375128V98.013313c0-16.031063 9.659223-30.925748 30.357558-30.925748L162.847194 64.936562c5.316631 0 9.598346-5.073121 9.598346-10.247705L172.486125 9.375737A9.517176 9.517176 0 0 0 162.847194 0.000609H96.389305zM96.389305 844.005656c-53.227189 0-96.389305-41.985152-96.389305-93.751282v-71.226623C0 673.853167 4.322299 669.652622 9.63893 669.652622h53.511284c5.336924 0 8.847524 4.200544 8.847524 9.375129v66.924616c0 16.031063 9.659223 30.925748 30.357558 30.925747l60.491898 2.211881c5.316631 0 9.598346 5.073121 9.598346 10.247705L172.486125 834.630528a9.517176 9.517176 0 0 1-9.638931 9.375128H96.389305z" p-id="4390" fill="#85D2FC"></path><path d="M806.626289 0.000609c53.227189 0 96.389305 41.96486 96.389305 93.751282v71.226623a9.517176 9.517176 0 0 1-9.63893 9.375128h-53.511284c-5.336924 0-8.847524-4.200544-8.847524-9.375128V98.013313c0-16.031063-9.659223-30.925748-30.357558-30.925748L740.1684 64.936562c-5.316631 0-9.598346-5.073121-9.598346-10.247705L730.529469 9.375737c0-5.174584 4.322299-9.375128 9.638931-9.375128h66.457889zM806.626289 844.005656c53.227189 0 96.389305-41.985152 96.389305-93.751282v-71.226623a9.517176 9.517176 0 0 0-9.63893-9.375129h-53.511284c-5.336924 0-8.847524 4.200544-8.847524 9.375129v66.924616c0 16.031063-9.659223 30.925748-30.357558 30.925747l-60.491898 2.211881c-5.316631 0-9.598346 5.073121-9.598346 10.247705L730.529469 834.630528c0 5.174584 4.322299 9.375128 9.638931 9.375128h66.457889z" p-id="4391" fill="#85D2FC"></path></svg>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-link type="primary" @click="reEmployesOpen(scope.row)"
                >重新入职</el-link
              >
              <el-link
                type="danger"
                style="margin-left: 24px"
                v-if="scope.row.status != 4"
                @click="delectUser(scope.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="newpagination" v-if="pages.total > 0">
        <div class="newpagination_text">共 {{ pages.total }} 条数据</div>
        <el-pagination
          layout="prev, pager, next"
          :total="pages.total"
          :current-page="pages.pageNum"
          :page-size="50"
          @current-change="chagePage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 删除员工弹窗 -->
    <Diglog
      @closeDiglog="closeDelete"
      @affirmDiglog="deleteEmployes(selectEmployees)"
      :isShow="delectUserDiglog"
      :title="'删除人员'"
      :tips="tips"
    />

    <!-- 重新入职 -->
    <Diglog
      @closeDiglog="closereEmploymen"
      @affirmDiglog="reEmployes(selectEmployees)"
      :isShow="reEmploymentDiglog"
      :title="'重新入职'"
      :tips="tips2"
    />

    <!-- 编辑员工弹窗 -->
    <el-drawer
      :wrapperClosable="false"
      title=""
      :key="selectEmployees"
      :visible.sync="reEmployment"
      :with-header="false"
      size="47%"
    >
      <ReEmployment
        @close="closeEmploy"
        @comfinEmploy="addUser"
        :id="selectEmployees"
        :deparment="selectEmployeesName"
      />
    </el-drawer>
  </div>
</template>

<script>
import Diglog from "../../../assembly/dialog.vue";
import Scree from "../module/member/scree.vue";

import ReEmployment from "../module/member/reEmployment.vue";
import Upload from "../module/member/upload.vue";
import Distribution from "../module/member/distribution.vue";

// 部门
import Branch from "../module/branch/newbranch.vue";
import showDialog from "../../../assembly/dialog.vue";
import Alteration from "../module/member/alterationdept.vue";

import http from "../../../utils/http";

import searchIcon from "../../../assets/structure/search.png";
import deleteIcon from "../../../assets/structure/delete.png";

import exprotExcel from "../../../utils/exprotExcel";
import multiblack from "../../../assets/structure/multiblack.png";
import multi from "../../../assets/structure/multi.png";

export default {
  data() {
    return {
      issuedKey: Math.random(),
      filterkey: Math.random(),
      screenKey: Math.random(),
      searchValue: "", //搜索内容
      searchForm: {}, //搜索表单
      searchMemicon: false, //删除图片是否显示(员工)
      searchicon: searchIcon, //搜索图标
      sidebarShow: true, //显示隐藏
      sidebarShoworder: true, //延迟1秒隐藏
      sidebarShowIcon: true, //图标显示时间
      delectUserDiglog: false, //删除员工弹窗
      reEmploymentDiglog: false, //重新入职弹窗
      reEmployment: false, //重新入职编辑
      multiblack,
      multi,

      resignationType: "", //离职类型
      handle: "", //经办人

      tips: "确认将该人员删除？删除后该人员信息将永久清除。",
      tips2: "确认为该人员办理重新入职？重新入职后将同步恢复该人员信息。",

      selectEmployees: null, //所选员工id
      selectEmployeesName: "", //所选员工部门名称

      refsName: 999, //ref控制显示隐藏

      companyName: "", //企业名称
      departmentList: [], //部门列表
      isExpand: false, //是否默认展开全部节点
      refreshTree: true, //动态渲染
      ischangec: "", //公司样式
      treeKey: "0",
      defaultProps: {
        children: "subDepartment",
        label: "departmentName",
      },

      filtrateResult: {}, //筛选字段

      // 部门操作
      businessClick: false, //企业选择
      resultClick: false, //搜索部门选择
      selectDivision: -1, //选择的部门
      alterationDiglog: false, //变更部门
      value: 1,
      tableData: [],
      pages: {}, //页码
      searchData: [], //搜索列表
      normalxi: true, //是否正常显示树状图
      searchfruit: {}, //搜索结果
      loading: false, //搜索等待
      addBranch: false, //添加子部门或编辑
      branchType: 1, //1是添加，2是子级，3是编辑
      tips: "", //提示
      deleteButton: false, //删除部门
      errorTips: false, //错误提示
      options: [
        {
          label: "自离",
          value: 0,
        },
        {
          label: "辞退",
          value: 1,
        },
        {
          label: "其他",
          value: 3,
        },
      ],
      tableColumn: [
        {
          title: "姓名",
          dataIndex: "name",
          id: 1,
        },
        {
          title: "员工工号",
          dataIndex: "jobNumber",
          id: 2,
        },
        {
          title: "设备工号",
          dataIndex: "deviceNumber",
          id: 3,
        },
        {
          title: "部门",
          dataIndex: "departmentName",
          id: 4,
        },
        {
          title: "职位",
          dataIndex: "job",
          id: 5,
        },
        {
          title: "离职类型",
          dataIndex: "resignation",
          id: 6,
        },
        {
          title: "离职日期",
          dataIndex: "timeQuit",
          id: 7,
        },
        {
          title: "离职原因",
          dataIndex: "leaveReason",
          id: 8,
        },
        {
          title: "经办人",
          dataIndex: "xx",
          id: 9,
        },
      ], //导出内容参数
    };
  },
  components: {
    Diglog,
    Scree,
    Upload,
    Distribution,
    ReEmployment,
    Branch,
    showDialog,
    Alteration,
  },

  watch: {
    "searchForm.likeString"(newName, oldName) {
      if (newName) {
        this.searchMemicon = true;
      } else {
        this.searchMemicon = false;
      }
    },
  },

  created() {
    // 获取部门列表
    var depatment = localStorage.getItem("department");
    depatment = JSON.parse(depatment);
    this.departmentList = depatment;
    // 获取员工列表
    this.getUser({
      pageNum: 1,
    });
  },

  // 点击任何地方取消下拉
  updated() {
    var that = this;
    that.$nextTick(() => {
      document.onclick = function () {
        if (that.$refs[`popoverRef_${that.refsName}`]) {
          that.$refs[`popoverRef_${that.refsName}`].doClose();
        }
      };
    });
  },

  methods: {
    // 平移动画
    translation() {
      this.sidebarShow = !this.sidebarShow;
      setTimeout(() => {
        this.sidebarShoworder = !this.sidebarShoworder;
      }, 100);

      // 图标变化
      setTimeout(() => {
        this.sidebarShowIcon = !this.sidebarShowIcon;
      }, 300);
    },

    // 表头背景颜色变色
    getRowClass({ rowIndex, columnIndex }) {
      if (rowIndex == 0) {
        return "background:#F5F6FA;color:#5C5C5C";
      }
    },

    // ----------------------------员工---------------------------
    // 获取员工列表
    getUser(value) {
      http
        .get(
          "/server/umsUser/list",
          Object.assign(
            {
              pageSize: 50,
              typeList: "-1",
            },
            value,
            this.searchForm
          )
        )
        .then((res) => {
          if (res.code == 200) {
            this.pages = res.data;
            this.tableData = res.data.list;
          }
        });
    },

    // 页数改变
    chagePage(e) {
      var value = {};
      if (Object.keys(this.filtrateResult).length === 0) {
        value = {
          pageNum: e,
          likeString: this.searchMember,
        };
      } else {
        value = Object.assign(this.filtrateResult, {
          pageNum: e,
        });
      }
      this.getUser(value);
    },

    // 筛选员工(姓名，身份证，工号筛选)
    seachmemResult() {
      // 清空筛选框
      this.filtrateResult = {};
      this.filtrateNum = 0;
      this.isFiltrate = false;

      this.getUser({
        pageNum: 1,
        likeString: this.searchMember,
      });
    },

    // 清除员工筛选
    clearupMember() {
      this.searchForm.likeString = "";

      this.getUser({
        pageNum: 1,
      });
    },

    // 删除员工
    delectUser(id) {
      setTimeout(() => {
        this.delectUserDiglog = true;
      }, 200);
      if (Array.isArray(id)) {
        this.tips = "确认将所选人员删除？删除后人员信息将永久清除。";
      } else {
        this.tips = "确认将该人员删除？删除后该人员信息将永久清除。";
      }
      this.selectEmployees = id;
    },

    // 关闭删除弹窗
    closeDelete() {
      this.selectEmployees = null;
      this.delectUserDiglog = false;
    },

    // 删除员工(确认)
    deleteEmployes(ids) {
      var that = this;
      var arr = [];
      if (Array.isArray(ids)) {
        arr = ids;
      } else {
        arr = [ids];
      }
      http
        .post("/server/umsUser/delete", {
          ids: arr,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message.success("删除成功");

            this.publicFiltering();
          } else {
            that.$message.error(res.message);
          }

          that.closeDelete();
        });
    },

    // 表格下载之前
    startDownload() {
      const loading = this.$loading({
        lock: true,
        text: "导出报表中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let target = event.target;
      if (target.nodeName == "I" || target.nodeName == "SPAN") {
        target = event.target.parentNode;
      }
      target.blur();
      let arr2 = [];
      for (let key of this.tableColumn) {
        arr2.push(key.key);
      }

      http
        .get(
          "/server/umsUser/list",
          Object.assign(this.searchForm, {
            pageNum: 1,
            typeList: "-1",
            pageSize: 99999,
          })
        )
        .then((res) => {
          if (res.code == 200) {
            loading.close();
            if (res.data.list.length > 0) {
              res.data.list.map((v) => {
                if (v.jobNumber) {
                  v.jobNumber = "\xa0" + v.jobNumber;
                }
                if (v.umsDepartment) {
                  v.departmentName = v.umsDepartment.name;
                }
                if (v.leaveType == 0) {
                  v.resignation = "自离";
                } else if (v.leaveType == 1) {
                  v.resignation = "辞退";
                } else if (v.leaveType == 3) {
                  v.resignation = "其他";
                }

                if (v.umsUser) {
                  v.xx = v.umsUser.name;
                }
                v.timeQuit = this.hadleQuit(v.timeQuit);
                for (let i = 0; i < arr2.length; i++) {
                  if (v[arr2[i]] == undefined) {
                    v[arr2[i]] = "";
                  }
                }
                for (let key in v) {
                  if (v[key] == null) v[key] = "";
                }
              });
              exprotExcel.export(
                this.tableColumn,
                res.data.list,
                "员工离职记录表"
              );
              this.$message.success("导出成功");
            } else {
              this.$message.error("无数据导出");
            }
          }
        });
    },

    // 重新入职弹窗
    reEmployesOpen(value) {
      this.reEmploymentDiglog = true;
      if (value) {
        this.selectEmployees = value.id;
        if (value.umsDepartment) {
          this.selectEmployeesName = value.umsDepartment.name;
        }
      }
    },
    // 关闭重新入职弹窗
    closereEmploymen() {
      this.selectEmployees = null;
      this.reEmploymentDiglog = false;
    },

    // 重新入职
    reEmployes() {
      this.reEmploymentDiglog = false;
      this.reEmployment = true;
    },
    // 新增员工
    addUser() {
      this.reEmployment = false;
      this.selectEmployees = null;
      // 重新获取员工列表
      this.publicFiltering();
    },
    // 关闭员工信息或者添加员工
    closeEmploy() {
      this.selectEmployees = null;
      this.reEmployment = false;
    },
    // 获取当天年月日时分秒
    getDateNon() {
      // 创建一个新的Date对象，该对象将自动包含当前日期和时间
      var currentDate = new Date();

      // 获取年份
      var year = currentDate.getFullYear();

      // 获取月份（注意月份从0开始，所以要加1）
      var month = currentDate.getMonth() + 1;

      // 获取日期
      var day = currentDate.getDate();

      return year + "-" + month + "-" + day + " " + "00:00:00";
    },

    // --------------------部门操作----------------------

    // -------------------------------------------------

    // 公用筛选
    publicFiltering() {
      var that = this;
      var value = {};
      if (Object.keys(that.filtrateResult).length === 0) {
        value = {
          pageNum: 1,
          departmentId: this.selectDivision < 0 ? "" : this.selectDivision,
        };
      } else {
        value = Object.assign(that.filtrateResult, {
          pageNum: 1,
          departmentId: this.selectDivision < 0 ? "" : this.selectDivision,
        });
      }

      that.getUser(value);
    },

    // 处理离职日期
    hadleQuit(value) {
      if (value) {
        var arr = value.split(" ");
        return arr[0];
      }
    },
  },
};
</script>

<style scoped>
.member {
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
.member_l {
  width: 0;
  height: 100%;
  position: relative;
  transition: all 0.5s ease 0ms;
}
.member_l_zoom {
  width: 330px;
  position: relative;
  transition: all 0.5s ease 0ms;
  border-right: 1px solid rgba(207, 212, 232, 0.5);
}
.member_company {
  width: 100%;
  height: 48px;
  display: flex;
  color: #5c5c5c;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.ischangec {
  background: rgba(242, 247, 255, 0.8);
  color: #0058ff;
}
.member_company span {
  font-size: 16px;
}
.multi {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.tree_sinle {
  width: 100%;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
.tree_sinle_a {
  display: flex;
  align-items: center;
}
.tree_sinle_l {
  font-size: 16px;
  max-width: 160px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #5c5c5c;
  /* color: #0058ff; */
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.tree_sinle_icon {
  width: 18px;
  height: 18px;
  margin-right: 12px;
}
.tree_multi {
  width: 24px;
  height: 24px;
}
.deptoption {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  box-sizing: border-box;
  color: #5c5c5c;
  cursor: pointer;
}
.deptoption:hover {
  background: #edeeee;
}
.tree_multi:hover {
  background: #e2e2e2;
  border-radius: 5px;
}
.multi:hover {
  background: #e2e2e2;
  border-radius: 5px;
}
.search {
  width: 100%;
  height: 72px;
  display: flex;
  padding-top: 22px;
  padding-left: 20px;
  box-sizing: border-box;
}
.search_input {
  width: 243px;
  height: 36px;
}
.membel_zoom {
  width: 28px;
  height: 36px;
  position: absolute;
  top: 22px;
  cursor: pointer;
  right: 0;
}
.membel_zoom_r {
  width: 28px;
  height: 36px;
  position: absolute;
  top: 20px;
  cursor: pointer;
  right: -27px;
}
.member_r {
  flex: 1;
  padding: 22px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.member_r_t_l {
  display: flex;
  height: 60px;
  justify-content: space-between;
  box-sizing: border-box;
}
.member_r_filter {
  display: flex;
  cursor: pointer;
  font-size: 15px;
  color: #b2b2b2;
  width: 98px;
  height: 36px;
  padding-left: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  align-items: center;
}
.member_r_filter_content {
  display: flex;
  cursor: pointer;
  font-size: 15px;
  color: #0058ff;
  width: 119px;
  height: 36px;
  padding-left: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid #0058ff;
  align-items: center;
}
.member_r_filter_icon {
  width: 18px;
  height: 18px;
  margin-left: 18px;
}
.memeber_table {
  width: 100%;
  flex: 1;
  position: relative;
}
.qrcode {
  width: 100%;
}
.qrcode_frame {
  width: 457px;
  height: 358px;
  display: flex;
  color: #1a1a1a;
  margin: 60px auto 24px;
  flex-direction: column;
  align-items: center;
  padding-top: 46px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
}
.qrcode_name {
  font-size: 16px;
  margin-bottom: 30px;
}
.qrcode_img {
  width: 200px;
  height: 200px;
}
.qrcode_tips {
  color: #9a9a9a;
  font-size: 15px;
  text-align: center;
}
.qrcode_bto {
  display: flex;
  margin-top: 39px;
  justify-content: center;
}
.link_frame {
  width: 797px;
  height: 132px;
  margin: 30px;
  font-size: 16px;
  padding: 24px;
  color: #1a1a1a;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
}
.link_tips {
  font-size: 15px;
  color: #9a9a9a;
  padding-left: 30px;
  box-sizing: border-box;
}
.link_bto {
  display: flex;
  margin-top: 289px;
  justify-content: center;
}
.invite_h {
  height: 73px;
  padding: 0 24px;
  color: #1a1a1a;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 18px;
  justify-content: space-between;
}
.invite_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.member_search {
  width: 243px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
.memeber_operation {
  margin-left: 8px;
  width: 107px;
}
.delectdiglog {
  width: 100%;
  margin-top: 20px;
  border-top: 1px solid #cfd4e8;
}
.delectdiglog_title {
  font-size: 16px;
  color: #1a1a1a;
  padding: 30px;
  box-sizing: border-box;
}
.diglog_h {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px 24px 0 24px;
  color: #1a1a1a;
}
.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.diglog_operation {
  margin: 60px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.member_name {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
}
.member_head {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}
.left {
  margin-left: 28px;
}
::v-deep .el-table__body .el-table__row.hover-row td {
  background-color: rgba(0, 98, 255, 0.05);
}
::v-deep .el-tree-node__content:hover {
  background: #f2f7ff;
}
.filtrate {
  display: flex;
  align-items: center;
}
.filtrate_single {
  padding: 6px;
  color: #0058ff;
  font-size: 15px;
  display: flex;
  align-items: center;
  background: #e0ecff;
  margin-right: 10px;
  border-radius: 4px;
}
.filtrate_icon {
  margin-left: 6px;
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.aselect {
  color: #1E40AF;
  background-color: rgba(0, 98, 255, 0.05);
}
.selectColor {
  color: #1E40AF;
}
.tree_case {
  height: 743px;
  overflow-y: scroll;
}
.tree_case::-webkit-scrollbar {
  display: none;
}
.approval_search {
  width: 243px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
.approval_search:focus-within {
  border-color: #0096fa;
}
.member_search:focus-within {
  border-color: #0096fa;
}
.m_table {
  width: 100%;
  height: 100%;
  margin-top: 16px;
  position: absolute;
}

::v-deep .member_r_t_dowm .el-input__inner {
  height: 36px;
  margin-left: 10px;
}
::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: none;
}
.member_r_t_left {
  display: flex;
  align-items: center;
}
.member_r_t_right {
  width: 80px;
  height: 36px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  font-size: 14px;
  color: #7e84a3;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
}
.structure_feature {
  display: flex;
  align-items: center;
}
.feature {
  width: 30px;
  height: 30px;
  margin-right: 12px;
}
.ellipsis {
  width: 150px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis; /* 显示省略号表示文本被截断 */
}
</style>
